import React, { useEffect, useState, useMemo } from "react";
import { toast, ToastContainer } from "react-toastify";
import ApiCallServices from "../../../../../services/ApiCallServices";
import { END_POINTS } from "../../../../../services/endpoint/endPoint";
import button from "../../../../button.module.css";
import ReachList from "./child/ReachList";

const Reach = () => {
  const initialState = {
    geo_id: "", // new field
    segment_id: "",
    reach: "",
    desktop: "",
    mobile: "",
    smartTV: "",
    banner: "",
    video: "",
    metro: "",
    non_metro: "",
    male: "",
    female: "",
  };

  const [tableData, setTableData] = useState([]);
  const [newReach, setNewReach] = useState(initialState);
  const [search, setSearch] = useState("");
  const [segments, setSegments] = useState([]);
  const [geoList, setGeoList] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [errors, setErrors] = useState({});
  const [showHideModal, setShowHideModal] = useState(false);
  const [showHideModal1, setShowHideModal1] = useState(false);
  const [loader, setLoader] = useState(false);
  const [sortingColumn, setSortingColumn] = useState(null);
  const [sortingOrder, setSortingOrder] = useState("asc");

  // Fetch all geo list
  const fetchGeoList = async () => {
    try {
      const res = await ApiCallServices.getlisting(
        END_POINTS.countryList + "?segmentStatus=1"
      );
      if (res.status === 200) {
        setGeoList(res.data.data);
      }
    } catch {
      toast.error("Failed to load countries");
    }
  };

  // Fetch segments filtered by geo_id
  const fetchSegmentsByGeo = async (geo_id = "") => {
    // if (!geo_id) {
    //   setSegments([]);
    //   return;
    // }
    try {
      const res = await ApiCallServices.create(END_POINTS.segmentssTableData, {
        geo_id,
        name: "",
      });
      if (res.status === 200) setSegments(res.data.data);
    } catch {
      toast.error("Failed to fetch segments");
    }
  };

  const updateStatus = async (id, status) => {
    try {
      const res = await ApiCallServices.create(END_POINTS.updateReachStatus, {
        id,
        status,
      });
      if (res.status === 200) {
        toast.success(res.data.message || "Status updated");
        getReachsTableData();
      }
    } catch (error) {
      toast.error("Failed to update status");
    }
  };

  const getReach = async (id) => {
    try {
      const res = await ApiCallServices.getlisting(
        `${END_POINTS.getReachById}/${id}`
      );
      if (res.status === 200) {
        const reachData = res.data.data;
        // Set Geo first
        setNewReach(reachData);
        setIsEditMode(true);
        setShowHideModal(true);
        document.body.style = "overflow: hidden";

        // Fetch segments filtered by reachData.geo_id
        if (reachData.geo_id) {
          await fetchSegmentsByGeo(reachData.geo_id);
        }
      }
    } catch {
      toast.error("Failed to fetch reach details");
    }
  };

  const getReachsTableData = async () => {
    setLoader(true);
    const data = {
      name: search,
      sortingcolumn: sortingColumn,
      sortingorder: sortingOrder,
    };
    try {
      const res = await ApiCallServices.create(END_POINTS.reachTableData, data);
      if (res.status === 200) setTableData(res.data.data);
    } catch {
      toast.error("Error fetching data");
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchSegmentsByGeo();
    getReachsTableData();
    fetchGeoList();
  }, [search, sortingColumn, sortingOrder]);

  // Handle Geo change: update geo_id, clear segment_id, fetch segments filtered by selected geo
  const handleGeoChange = async (e) => {
    const geo_id = e.target.value;
    setNewReach((prev) => ({
      ...prev,
      geo_id,
      segment_id: "", // clear segment when geo changes
    }));

    await fetchSegmentsByGeo(geo_id);
  };

  // Handle other inputs including segment_id
  const handleInput = (e) => {
    const { name, value } = e.target;
    setNewReach((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    const errors = {};
    if (!newReach.geo_id) errors.geo_id = "Geo is required";
    if (!newReach.segment_id) errors.segment_id = "Segment is required";
    if (!newReach.reach) errors.reach = "Reach is required";
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    try {
      const res = isEditMode
        ? await ApiCallServices.create(END_POINTS.updateReach, newReach)
        : await ApiCallServices.create(END_POINTS.createReach, newReach);

      if (res.status === 200) {
        toast.success(res.data.message);
        resetForm();
        getReachsTableData();
      }
    } catch {
      toast.error("Operation failed");
    }
  };

  const resetForm = () => {
    setIsEditMode(false);
    setNewReach(initialState);
    setSegments([]);
    setShowHideModal(false);
    document.body.removeAttribute("style");
    setErrors({});
  };

  // Helper outside component
  const groupSegments = (segments) => {
    const grouped = {};

    segments.forEach((seg) => {
      if (seg.parent_id === 0) {
        grouped[seg.id] = { ...seg, subsegments: [] };
      }
    });

    segments.forEach((seg) => {
      if (seg.parent_id !== 0 && grouped[seg.parent_id]) {
        grouped[seg.parent_id].subsegments.push(seg);
      }
    });

    return Object.values(grouped);
  };

  // Inside your component
  const groupedSegments = useMemo(() => groupSegments(segments), [segments]);

  const deleteReach = async (id) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;

    try {
      const res = await ApiCallServices.create(
        END_POINTS.deleteReach, 
        { id }
      );
      if (res.status === 200) {
        toast.success(res.data.message || "Reach deleted successfully");
        getReachsTableData();
      }
    } catch {
      toast.error("Failed to delete reach");
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="container-fluid">
      <div className='filter-wraper justify-content-between'>
          <div className='d-flex align-items-center fields'>
              <h3>Manage Reach</h3>
          </div>
      </div>

        <div className="filter-wraper d-flex justify-content-between">
          <div className="d-flex align-items-center fields">
            <div className="form-group search-icon">
              <input
                type="text"
                className="form-control"
                onChange={(e) =>
                  setSearch(e.target.value.length > 1 ? e.target.value : "")
                }
                placeholder="Search reach"
              />
            </div>
          </div>
          <div className="form-group d-flex justify-content-end">
            <button
              type="button"
              className={`${button.btn} ${button.btnDarkBlue}`}
              onClick={() => {
                setShowHideModal(true);
                document.body.style = "overflow: hidden";
              }}
            >
              Add New Reach
            </button>
          </div>
        </div>

        <ReachList
          tableData={tableData}
          getReach={getReach}
          search={search}
          updateStatus={updateStatus}
          loader={loader}
          sortingColumn={sortingColumn}
          deleteReach={deleteReach}
          sortingOrder={sortingOrder}
          onSort={(col) => {
            setSortingColumn((prev) => (prev === col ? col : col));
            setSortingOrder((prev) =>
              sortingColumn === col ? (prev === "asc" ? "desc" : "asc") : "asc"
            );
          }}
        />
      </div>

      <div className={`modal form-modal ${showHideModal ? "show" : ""}`}>
        <div className="modal-dialog modal-md modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                {isEditMode ? "Update Reach" : "Create New Reach"}
              </h4>
              <i
                className="fa-regular fa-circle-xmark close-icon"
                onClick={resetForm}
              ></i>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="form-wraper">
                  {/* Geo Dropdown */}
                  <div className="form-group">
                    <label>
                      Geo <span className="astric">*</span>
                    </label>
                    <select
                      name="geo_id"
                      value={newReach.geo_id}
                      onChange={handleGeoChange}
                      className="form-control"
                      disabled={isEditMode} // disable in edit mode
                    >
                      <option value="">Select Geo</option>
                      {geoList.map((geo) => (
                        <option key={geo.id} value={geo.ccode}>
                          {geo.name}
                        </option>
                      ))}
                    </select>
                    {errors?.geo_id && (
                      <div className="input-error">{errors.geo_id}</div>
                    )}
                  </div>

                  {/* Segment Dropdown */}
                  <div className="form-group">
                    <label>
                      Segment <span className="astric">*</span>
                    </label>
                    <select
                      name="segment_id"
                      value={newReach.segment_id}
                      onChange={handleInput}
                      className="form-control"
                    >
                      <option value="">Select Segment</option>
                      {groupedSegments.map((parent) => (
                        <optgroup key={parent.id} label={parent.name}>
                          {parent.subsegments.length > 0 ? (
                            parent.subsegments.map((child) => (
                              <option key={child.id} value={child.id}>
                                {child.name}
                              </option>
                            ))
                          ) : (
                            <option value={parent.id}>{parent.name}</option>
                          )}
                        </optgroup>
                      ))}
                    </select>

                    {errors?.segment_id && (
                      <div className="input-error">{errors.segment_id}</div>
                    )}
                  </div>

                  {/* Other numeric fields */}
                  <div className="row">
                    {[
                      "reach",
                      "desktop",
                      "mobile",
                      "smartTV",
                      "banner",
                      "video",
                      "metro",
                      "non_metro",
                      "male",
                      "female",
                    ].map((field) => (
                      <div className="form-group col-md-6" key={field}>
                        <label>
                          {field.charAt(0).toUpperCase() + field.slice(1)}
                        </label>
                        <input
                          type="number"
                          name={field}
                          value={newReach[field] || ""}
                          onChange={handleInput}
                          className="form-control"
                        />
                      </div>
                    ))}
                  </div>

                  <div className="text-end">
                    <button
                      type="submit"
                      className={`${button.btn} ${button.btnBlue}`}
                    >
                      {isEditMode ? "Update" : "Save"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`${showHideModal || showHideModal1 ? "overlay" : ""}`}
      ></div>
    </>
  );
};

export default Reach;
